<p-dialog
    header="Reassign company"
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    [style]="{ width: '32rem' }"
    [modal]="true"
    [closable]="!saving()"
>
    <p-fluid>
        <div class="flex flex-col gap-4">
            <div class="text-sm text-muted-color">
                Move this website to a different company. The change applies immediately and is independent of other unsaved edits on this page.
            </div>

            <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                    <label class="font-semibold">Company</label>
                    <div class="flex gap-1 text-xs">
                        <button
                            type="button"
                            class="px-2 py-0.5 rounded border"
                            [class.border-primary]="mode() === 'select'"
                            [class.text-primary]="mode() === 'select'"
                            [class.border-surface-300]="mode() !== 'select'"
                            [class.text-muted-color]="mode() !== 'select'"
                            [disabled]="saving()"
                            (click)="toggleMode('select')"
                        >Select existing</button>
                        <button
                            type="button"
                            class="px-2 py-0.5 rounded border"
                            [class.border-primary]="mode() === 'create'"
                            [class.text-primary]="mode() === 'create'"
                            [class.border-surface-300]="mode() !== 'create'"
                            [class.text-muted-color]="mode() !== 'create'"
                            [disabled]="saving()"
                            (click)="toggleMode('create')"
                        >+ New</button>
                    </div>
                </div>

                @if (mode() === 'select') {
                    <p-select
                        [options]="companyOptions()"
                        [ngModel]="selectedCompanyId()"
                        (ngModelChange)="selectedCompanyId.set($event)"
                        [filter]="true"
                        placeholder="Select a company"
                        appendTo="body"
                        [disabled]="saving()"
                    ></p-select>
                    @if (companyError()) {
                        <small class="text-red-500">{{ companyError() }}</small>
                    }
                } @else {
                    <div class="border border-surface-200 dark:border-surface-700 rounded p-3 flex flex-col gap-3">
                        <div class="flex flex-col gap-1">
                            <label for="reassignNewName" class="text-sm">Name</label>
                            <input
                                pInputText
                                id="reassignNewName"
                                [ngModel]="newName()"
                                (ngModelChange)="newName.set($event)"
                                placeholder="Acme Holdings Ltd."
                                [disabled]="saving()"
                            />
                            @if (nameError()) {
                                <small class="text-red-500">{{ nameError() }}</small>
                            }
                        </div>
                        <div class="flex flex-col gap-1">
                            <label for="reassignNewCountry" class="text-sm">Country</label>
                            <p-select
                                inputId="reassignNewCountry"
                                [options]="countryOptions"
                                optionLabel="label"
                                optionValue="value"
                                [ngModel]="newCountryCode()"
                                (ngModelChange)="newCountryCode.set($event)"
                                [filter]="true"
                                [showClear]="true"
                                placeholder="Select a country"
                                appendTo="body"
                                [disabled]="saving()"
                            >
                                <ng-template let-option #item>
                                    <div class="flex items-center gap-2">
                                        <span [class]="'flag flag-' + option.value.toLowerCase()" style="width: 18px; height: 12px"></span>
                                        <span>{{ option.label }}</span>
                                    </div>
                                </ng-template>
                                <ng-template let-option #selectedItem>
                                    @if (option) {
                                        <div class="flex items-center gap-2">
                                            <span [class]="'flag flag-' + option.value.toLowerCase()" style="width: 18px; height: 12px"></span>
                                            <span>{{ option.label }}</span>
                                        </div>
                                    }
                                </ng-template>
                            </p-select>
                            @if (countryError()) {
                                <small class="text-red-500">{{ countryError() }}</small>
                            }
                        </div>
                        <div class="flex flex-col gap-1">
                            <label for="reassignNewAddress" class="text-sm">Address</label>
                            <textarea
                                pTextarea
                                id="reassignNewAddress"
                                rows="2"
                                [ngModel]="newAddress()"
                                (ngModelChange)="newAddress.set($event)"
                                [disabled]="saving()"
                            ></textarea>
                            @if (addressError()) {
                                <small class="text-red-500">{{ addressError() }}</small>
                            }
                        </div>
                        <div class="flex flex-col gap-1">
                            <label for="reassignNewReg" class="text-sm">Registration details</label>
                            <textarea
                                pTextarea
                                id="reassignNewReg"
                                rows="2"
                                [ngModel]="newRegDetails()"
                                (ngModelChange)="newRegDetails.set($event)"
                                placeholder="Reg. no. / VAT / Tax ID"
                                [disabled]="saving()"
                            ></textarea>
                            @if (regError()) {
                                <small class="text-red-500">{{ regError() }}</small>
                            }
                        </div>
                    </div>
                }
            </div>

            @if (generalError()) {
                <small class="text-red-500">{{ generalError() }}</small>
            }
        </div>
    </p-fluid>
    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" [disabled]="saving()" (onClick)="close()" />
            <p-button
                label="Reassign"
                icon="pi pi-arrow-right-arrow-left"
                [loading]="saving()"
                [disabled]="!hasChange()"
                (onClick)="confirm()"
            />
        </div>
    </ng-template>
</p-dialog>
